module.exports = __webpack_public_path__ + "img/icon-hook-red.8d40850f.svg";